import { motion } from "framer-motion";
import { personal } from "@/data/portfolio";

const word = {
  hidden: { y: "110%" },
  show: (i = 0) => ({
    y: "0%",
    transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.12 + i * 0.07 },
  }),
};

export default function Hero() {
  return (
    <section id="top" className="hero" data-testid="hero-section">
      <div className="hero__grid">
        <div className="hero__meta">
          <span className="overline" data-testid="hero-overline">
            ◆ Portfolio · {personal.yearsActive}
          </span>
          <span className="overline overline--muted">{personal.location}</span>
        </div>

        <h1 className="hero__title" data-testid="hero-title" aria-label="Designing attention and the communities around it.">
          <div className="line">
            <motion.span variants={word} initial="hidden" animate="show" custom={0} className="word">
              Designing
            </motion.span>
            <motion.span variants={word} initial="hidden" animate="show" custom={1} className="word italic">
              attention
            </motion.span>
          </div>
          <div className="line">
            <motion.span variants={word} initial="hidden" animate="show" custom={2} className="word">
              &amp; the
            </motion.span>
            <motion.span variants={word} initial="hidden" animate="show" custom={3} className="word italic">
              communities
            </motion.span>
          </div>
          <div className="line">
            <motion.span variants={word} initial="hidden" animate="show" custom={4} className="word">
              around it.
            </motion.span>
          </div>
        </h1>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.75, ease: [0.22, 1, 0.36, 1] }}
          className="hero__intro"
          data-testid="hero-intro"
        >
          <p>{personal.intro}</p>
          <div className="hero__sign">
            <span className="overline">Hi, I&apos;m</span>
            <h2 className="serif italic" data-testid="hero-name">
              {personal.signatureName}
            </h2>
            <span className="hero__role">{personal.tagline}</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
